import type { CSSProperties, ReactNode } from 'react';
import { slowCn } from '@unifyapps/ui/lib/utils';

export function PageWorkspace({
  children,
  className,
  style,
  ...rest
}: {
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
}) {
  return (
    <main
      className={slowCn(
        'ua-page-workspace bg-workspace flex min-h-0 flex-1 flex-col overflow-hidden',
        className,
      )}
      data-name="workspace"
      style={style}
      {...rest}
    >
      {children}
    </main>
  );
}
